import Collapsible from './Collapsible.vue'

export { Collapsible }
export default Collapsible
